export function SignWaitIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill="currentColor"
        fillOpacity="0.54"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.2304 3.91481C14.4908 4.17515 14.4908 4.59726 14.2304 4.85761L6.68793 12.4001C6.42758 12.6604 6.00547 12.6604 5.74512 12.4001L1.52861 8.1836C1.26826 7.92325 1.26826 7.50114 1.5286 7.24079C1.78895 6.98044 2.21106 6.98044 2.47141 7.24079L6.21653 10.9859L13.2876 3.91481C13.548 3.65446 13.9701 3.65446 14.2304 3.91481Z"
      />
    </svg>
  );
}
